import React from "react";
import SidenavTitle from "./SidenavTitle";
import {
  workLinks,
  projectLinks,
  publicationLinks,
  reachMe,
} from "../../../data/sidenav";

const LinkList = ({ links }) => (
  <ul>
    {links.map(({ href, label }) => (
      <li key={label} className="sidenavLi">
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-designColor"
        >
          {label}
        </a>
      </li>
    ))}
  </ul>
);

const Sidenav = () => {
  return (
    <div className="px-7 py-4">
      <div className="flex justify-center items-center bg-bodyColor">
        <h1 className="text-4xl font-bold text-strongColor">External Links</h1>
      </div>

      <SidenavTitle title="W" subTitle="ork Experience" />
      <LinkList links={workLinks} />

      <SidenavTitle title="P" subTitle="rojects" />
      <LinkList links={projectLinks} />

      <SidenavTitle title="P" subTitle="ublications" />
      <LinkList links={publicationLinks} />

      <SidenavTitle title="R" subTitle="each Me" />
      <ul>
        {reachMe.map((item) => (
          <li key={item} className="sidenavLi">
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidenav;
